module.exports = __webpack_public_path__ + "static/media/Iris Street, San Francisco, CA12.ab43d51c.jpg";